module.exports = __webpack_public_path__ + "img/1482681355.b001efd4.jpg";